module.exports = __webpack_public_path__ + "img/Villageois.72be45ff.png";